<script setup lang="ts">
import MsgReplyMenu from "@/views/ChatMessage/MsgReplyMenu.vue";
import MsgSeekPart from "@/views/ChatMessage/MsgSeekPart.vue";
import { isCompactMode } from "@/data/pubilc";
import UaMarkdown from "@/components/ua2-markdown/ua-markdown.vue";
import CsdVditor from "@/components/vditor/csd-vditor.vue";
import { defineProps, toRefs, computed } from "vue";
import {
  chatList,
  chatStatus,
  deleteChatObj,
  sendMsg,
} from "@/views/Home/useData/module/chat";
import { v3 } from "uuid";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import { storeToRefs } from "pinia";
import publicStore from "@/store/publicStore";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { showVIPDialogue } from "@/components/Dialogues/useData/useDialogues";

const { isLogin, isVip } = storeToRefs(publicStore());

const props = defineProps({
  msgObj: {
    type: Object,
    required: true,
  },
  msgIndex: {
    type: Number,
    required: true,
  },
});

const { msgObj, msgIndex } = toRefs(props);

const showCotent = computed(() => {
  if (chatList.length === 0) {
    return "";
  }
  const msgItem = chatList[chatList.length - 1] as any;
  const replying =
    msgItem.id === msgObj.value.id &&
    chatStatus.isReplying &&
    !msgObj.value.content;
  return replying ? "正在回复..." : msgObj.value.content;
});

const isReplying = computed(() => {
  if (chatList.length === 0) {
    return false;
  }
  return (
    chatList[chatList.length - 1].id === msgObj.value.id &&
    chatStatus.isReplying
  );
});

const isLastOne = computed(() => {
  return msgIndex.value === chatList.length - 1;
});

const isSpecialist = computed(() => {
  return false;
  // return ["Specialist"].includes((this.sessionId || "").split(".")[0]);
});

const menuAction = (index: number) => {
  //0 copy 1 resend
  if (index === 0) {
    ElMessage.success("已复制");
    Clipboard.copy(msgObj.value.content);
  } else {
    //删除原来的，重新发送
    if (!isLogin.value) {
      openLoginDialog();
      return;
    }

    if (isReplying.value) {
      return;
    }

    if (!isVip.value) {
      showVIPDialogue.value = true;
      return;
    }

    const chat = msgObj.value as any;
    const chatUser = chatList.find((i) => i.id == chat.id && i.role == "user");
    if (!chatUser) return;
    deleteChatObj(chat.id);
    sendMsg(chatUser.content);
  }
};
</script>

<template>
  <div class="msg-reply">
    <div
      class="body"
      :class="{ 'body-compact': isCompactMode, 'bottom-space': isLastOne }"
    >
      <img src="@/assets/logo.png" class="icon" />
      <div class="reply-body">
        <div class="reply-msg">
          <UaMarkdown
            :source="showCotent"
            :showLine="false"
            v-if="isReplying"
          />
          <CsdVditor
            :point="item.key"
            :content="showCotent"
            v-model:vditorShowInAi="vditorShowInAiStatus"
            v-else-if="isSpecialist"
          />
          <UaMarkdown :source="showCotent" :showLine="false" v-else />
        </div>
        <MsgReplyMenu v-if="!isReplying" @menuAction="menuAction" />

        <!--        <MsgSeekPart />-->
        <el-popover
          v-if="false"
          placement="bottom-start"
          :width="80"
          trigger="hover"
          :show-arrow="false"
          popper-class="my-popper"
        >
          <template #reference>
            <div class="reply-msg">
              <UaMarkdown
                :source="showCotent"
                :showLine="false"
                v-if="isReplying"
              />
              <CsdVditor
                :point="item.key"
                :content="showCotent"
                v-model:vditorShowInAi="vditorShowInAiStatus"
                v-else-if="isSpecialist"
              />
              <UaMarkdown :source="showCotent" :showLine="false" v-else />
            </div>
          </template>
          <MsgReplyMenu v-if="!isReplying" @menuAction="menuAction" />
        </el-popover>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.msg-reply {
  width: 100%;
  display: flex;
  user-select: text;

  .body {
    padding: 12px 16px;
    display: flex;
    gap: 4px;
    align-items: start;
    margin-bottom: 0px;

    .icon {
      width: 38px;
      height: 38px;
    }

    .reply-body {
      display: flex;
      flex: 1;
      flex-direction: column;

      .reply-msg {
        display: flex;
        font-size: 16px;
        margin-top: 8px;
      }
    }
  }

  .bottom-space {
    margin-bottom: 50px;
  }

  .body-compact {
    padding: 12px 0px;
  }
}
</style>
